import React from 'react';

import './GoalCardDropArea.scss';

function GoalCardDropArea() {
  return <div className="GoalCardDropArea d-flex align-items-center justify-content-center w-100 h-100">Drop here</div>;
}

export default GoalCardDropArea;
